// Actions
export const GET_KIP_FILTER_API_DATA = "GET_KIP_FILTER_API_DATA";
export const KIP_FILTER_API_RESPONSE_SUCCESS = "KIP_FILTER_API_RESPONSE_SUCCESS";
export const GET_KIP_WIDGET_API_DATA = "GET_KIP_WIDGET_API_DATA";
export const KIP_WIDGET_API_RESPONSE_SUCCESS = "KIP_WIDGET_API_RESPONSE_SUCCESS";
export const GET_KIP_FORECAST_API_DATA = "GET_KIP_FORECAST_API_DATA";
export const KIP_FORECAST_API_RESPONSE_SUCCESS = "KIP_FORECAST_API_RESPONSE_SUCCESS";
export const GET_KIP_SERVER_PERFORMANCE_API_DATA = "GET_KIP_SERVER_PERFORMANCE_API_DATA";
export const KIP_SERVER_PERFORMANCE_API_RESPONSE_SUCCESS = "KIP_SERVER_PERFORMANCE_API_RESPONSE_SUCCESS";